angular.module('rjmNg.constants')
.constant('operatorEnums'

  NULL: '[NULL]'

  COMPARISON_OPERATOR_NAMES: Object.freeze
    'Greater Than or Equal to': 'GREATER_OR_EQUAL'
    'Greater Than': 'GREATER'
    'Less Than or Equal to': 'LESS_OR_EQUAL'
    'Less Than': 'LESS'
    'Equal to': 'EQUAL'
    'Not Equal to': 'NOT_EQUAL'
    'Like': 'LIKE'
    'Is': 'IS'
    'Is Not': 'IS_NOT'
    'Not Like': 'NOT_LIKE'
    'In': 'IN'
    'Not In': 'NOT_IN'

  COMPARISON_OPERATOR_SYMBOLS: Object.freeze
    'GREATER_OR_EQUAL': '>='
    'GREATER': '>'
    'LESS_OR_EQUAL': '<='
    'LESS': '<'
    'EQUAL': '='
    'NOT_EQUAL': '!='
    'LIKE': 'LIKE'
    'IS': 'IS'
    'IS_NOT': 'IS NOT'
    'NOT_LIKE': 'NOT LIKE'
    'IN': 'IN'
    'NOT_IN': 'NOT IN'

  SCHEMA_SERVICE_COMPARISON_OPERATOR_SYMBOLS: Object.freeze
    'GREATER_OR_EQUAL': '>='
    'GREATER': '>'
    'LESS_OR_EQUAL': '<='
    'LESS': '<'
    'EQUAL': '='
    'NOT_EQUAL': '!='
    'LIKE': 'like'
    'IS': 'is_null'
    'IS_NOT': 'is_not_null'
    'NOT_LIKE': 'not_like'
    'IN': 'in'
    'NOT_IN': 'not_in'

  COMPARISON_OPERATOR_IDS: Object.freeze
    '>=': 'GREATER_OR_EQUAL'
    '>': 'GREATER'
    '<=': 'LESS_OR_EQUAL'
    '<': 'LESS'
    '=': 'EQUAL'
    '!=': 'NOT_EQUAL'
    'LIKE': 'LIKE'
    'IS': 'IS'
    'IS NOT': 'IS_NOT'
    'NOT LIKE': 'NOT_LIKE'
    'IN': 'IN'
    'NOT IN': 'NOT_IN'

  SCHEMA_SERVICE_COMPARISON_OPERATOR_IDS: Object.freeze
    '>=': 'GREATER_OR_EQUAL'
    '>': 'GREATER'
    '<=': 'LESS_OR_EQUAL'
    '<': 'LESS'
    '=': 'EQUAL'
    '!=': 'NOT_EQUAL'
    'like': 'LIKE'
    'is_null': 'IS'
    'is_not_null': 'IS_NOT'
    'not_like': 'NOT_LIKE'
    'in': 'IN'
    'not_in': 'NOT_IN'

  DATE_COMPARISON_OPERATOR_NAMES: Object.freeze
    'Greater Than or Equal to': 'GREATER_OR_EQUAL'
    'Greater Than': 'GREATER'
    'Less Than or Equal to': 'LESS_OR_EQUAL'
    'Less Than': 'LESS'
    'Equal to': 'EQUAL'
    'Not Equal to': 'NOT_EQUAL'
    'Is': 'IS'
    'Is Not': 'IS_NOT'

  GA_COMPARISON_OPERATOR_SYMBOLS: Object.freeze
    "EQUAL": '=~'
    "NOT_EQUAL": '!~'
    "IN": '=@'
    "NOT_IN": '!@'
    "IS": '=='
    "IS_NOT": '!='

  GA_COMPARISON_OPERATOR_IDS: Object.freeze
    '=~': "EQUAL"
    '!~': "NOT_EQUAL"
    '=@': "IN"
    '!@': "NOT_IN"
    '==': "IS"
    '!=': "IS_NOT"

  GA_COMPARISON_OPERATOR_NAMES: Object.freeze
    'Contains a match for the regular expression': 'EQUAL'
    'Does not match regular expression': 'NOT_EQUAL'
    'Contains substring': 'IN'
    'Does not contain substring': 'NOT_IN'
    'Exact match': 'IS'
    'Does not match': 'IS_NOT'

  GA4_COMPARISON_OPERATOR_SYMBOLS: Object.freeze
    "EQUAL": '=~'
    "NOT_EQUAL": '!~'
    "IN": '=@'
    "NOT_IN": '!@'
    "IS_GA4": '=='
    "IS_NOT_GA4": '!='
    "IS": '=='
    "IS_NOT": '!='

  GA4_COMPARISON_OPERATOR_IDS: Object.freeze
    '=~': "EQUAL"
    '!~': "NOT_EQUAL"
    '=@': "IN"
    '!@': "NOT_IN"
    '==': "IS_GA4"
    '!=': "IS_NOT_GA4"

  GA4_COMPARISON_OPERATOR_NAMES: Object.freeze
    'Contains a match for the regular expression': 'EQUAL'
    'Does not match regular expression': 'NOT_EQUAL'
    'Contains substring': 'IN'
    'Does not contain substring': 'NOT_IN'
    'Exact match': 'IS_GA4'
    'Does not match': 'IS_NOT_GA4'
)
